<template>
  <div :class="containerClass">
    <page-header
      title="Intro Video"
      :container-class="null"
      class="mb-32pt"
      infoText="Upload your introduction video."
    />

    <page-separator title="" />
    <b-skeleton-wrapper :loading="isLoading">
      <template #loading>
        <div class="d-flex justify-content-center">
          <div class="card card-block card-stretch card-height col-md-12">
            <div class="card-body text-center">
              <i class="fas fa-photo-video fa-lg text-muted mt-4 mb-4" style="font-size: 3rem" />

              <p><b-skeleton width="60%"></b-skeleton></p>
              <p><b-skeleton width="90%"></b-skeleton></p>
              <p><b-skeleton width="75%"></b-skeleton></p>
              <div class="d-flex justify-content-center">
                <b-skeleton type="button" width="250px"></b-skeleton>
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- <div
        class="d-flex justify-content-center"
        v-if="isUploadingVideo  && !uploaded_video_url"
      >
        <div class="card card-block card-stretch card-height col-md-12">
          <div class="card-body text-center">
            <i class="fas fa-circle-notch fa-spin fa-lg text-muted mt-4 mb-4" style="font-size: 3rem" />
            <h4>Video Uploading...</h4>
            <p class="text-muted">
              Feel free to leave this page. Your video will remain uploading in the background and will show up here
              when finished
            </p>
          </div>
        </div>
      </div> -->

      <div class="d-flex justify-content-center" v-if="!intro_video_url">
        <div class="card card-block card-stretch card-height col-md-12">
          <div class="card-body text-center">
            <i class="fas fa-photo-video fa-lg text-muted mt-4 mb-4" style="font-size: 3rem" />
            <h4>Upload Your Video</h4>
            <p class="text-muted">upload a video telling us your name and the reason you enrolled in the program.</p>
            <div>
              <b-btn
                variant="primary"
                style="width: 150px"
                @click.prevent="$refs.uploader.click()"
                class="btn-normal"
                :disabled="isUploadingVideoUrl"
              >
                <i v-if="isUploadingVideoUrl" class="fas fa-circle-notch fa-spin"></i>
                <span v-else>Upload Intro</span>
              </b-btn>
              <input type="file" ref="uploader" class="d-none" @change="handleFileChange" accept="video/*" />
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-center" v-else>
        <div class="card card-block card-stretch card-height col-md-12">
          <div class="card-body">
            <!-- <h5>Primary</h5>
            <p class="mb-1">Your primary billing method is used for all recurring payments.</p> -->

            <page-separator title="" />
            <div class="d-flex align-items-center">
              <video
                style="width: 100%; margin: auto;height: 450px;"
                id="video-preview"
                controls
                :src="intro_video_url"
              />
            </div>
            <!-- <p class="text-muted mt-1">
              Note: To change the default payment method, remove the existing method and add a new one.
            </p> -->

            <div class="d-flex justify-content-end mt-3">
              <b-btn
                v-if="$route.query.success != 1"
                variant="success"
                @click.prevent="saveVideo"
                class="btn-normal mr-2"
                :disabled="isSaving"
                style="width: 120px"
              >
                <i v-if="isSaving" class="fas fa-circle-notch fa-spin"></i>
                <span v-else>Save</span>
              </b-btn>
              <b-btn
                variant="danger"
                @click.prevent="removeVideo"
                class="btn-normal"
                :disabled="isRemoving"
                style="width: 120px"
              >
                <i v-if="isRemoving" class="fas fa-circle-notch fa-spin"></i>
                <span v-else>Remove</span>
              </b-btn>
            </div>
          </div>
        </div>
      </div>
    </b-skeleton-wrapper>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import PageSeparator from '@/components/Ui/PageSeparator.vue';
import PageHeader from '@/components/Ui/PageHeader.vue';
import Page from '@/components/Page.vue';
//import { get } from 'lodash';
export default {
  name: 'ManageIntroVideoPage',
  components: {
    PageSeparator,
    PageHeader,
  },
  extends: Page,
  data() {
    return {
      title: 'My Introduction Video',
      intro_video_url: null,
      isLoading: false,
      isSaving: false,
      isRemoving: false,
      isUploadingVideoUrl: false,
      uploaded_video_url: null,
    };
  },
  computed: {
    breadcrumb() {
      return [
        { text: this.$t('home'), to: this.routes.home },
        { text: 'Manage Introduction Video', active: true },
      ];
    },
  },

  methods: {
    ...mapActions('student', ['getMyStudentProfile', 'getVideoUrl', 'updateIntroVideoUrl', 'postIntroVideoUrl']),
    ...mapActions('school', ['getSchoolImageUploadPresignedUrl']),
    ...mapActions('s3Upload', ['uploadToPresignedUrl']),
    async fetchStudentProfile() {
      this.isLoading = true;
      try {
        const resp = await this.getMyStudentProfile(true);
        this.intro_video_url = resp.intro_video_url;
        if (this.intro_video_url) {
          this.$router.replace({
            name: 'manage-intro-video',
            query: { success: 1 },
          });
        } else {
          this.$router.replace({
            name: 'manage-intro-video',
          });
        }
        this.isLoading = false;
      } catch (error) {
        this.makeToast({ variant: 'danger', msg: this.$t('generalMsgs.genErrorMsg') });
        this.isLoading = false;
      }
    },
    handleFileChange(event) {
      const file = event.target.files[0];

      if (file) {
        this.uploadVideo(file);
      }
    },
    async saveVideo() {
      this.isSaving = true;

      try {
        await this.postIntroVideoUrl({ intro_video_url: this.intro_video_url });
        this.makeToast({ variant: 'success', msg: 'Saved Successfully!' });
        this.$router.replace({
          name: 'manage-intro-video',
          query: { success: 1 },
        });
      } catch (_err) {
        this.makeToast({ variant: 'danger', msg: this.$t('generalMsgs.genErrorMsg') });
        this.isSaving = false;
        return;
      }
      this.isSaving = false;
    },
    async removeVideo() {
      this.isRemoving = true;
      const isConfirmed = await this.$bvModal.msgBoxConfirm(
        'Please confirm that you want to remove your introduction video.',
        {
          title: 'Remove Video',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        },
      );
      if (isConfirmed) {
        try {
          await this.updateIntroVideoUrl();
          this.intro_video_url = null;
          this.makeToast({ variant: 'success', msg: 'Intro Video Removed!' });
          this.fetchStudentProfile();
        } catch (_err) {
          this.makeToast({ variant: 'danger', msg: this.$t('generalMsgs.genErrorMsg') });
        }
      }
      this.isRemoving = false;
    },

    async uploadVideo(file) {
      this.isUploadingVideoUrl = true;

      if (file.size > 25000000) {
        this.makeToast({ variant: 'danger', msg: 'File size should not exceed 25MB' });
        this.isUploadingVideoUrl = false;
        return;
      }
      if (!['video/mp4', 'video/webm'].includes(file.type)) {
        this.makeToast({ variant: 'danger', msg: 'File type should be mp4 or webm' });

        this.isUploadingVideoUrl = false;
        return;
      }

      try {
        const urlResp = await this.getSchoolImageUploadPresignedUrl({
          file_name: file.name,
          content_type: file.type,
        });
        await this.uploadToPresignedUrl({
          url: urlResp.upload_url,
          file: file,
        });
        this.intro_video_url = urlResp.upload_url.split('?')[0];
      } catch (error) {
        this.isUploadingVideoUrl = false;
        return;
      }
      this.isUploadingVideoUrl = false;
    },
  },

  async mounted() {
    // this.isUploadingVideo = true;
    this.fetchStudentProfile();

    // if (!this.intro_video_url) {
    //   this.isUploadingVideo = true;
    //   const resp = await this.getMyStudentProfile(true);
    //   this.uploaded_video_url = resp.intro_video_url;
    //   this.intro_video_url = resp.intro_video_url;
    //   if (this.intro_video_url || this.uploaded_video_url) {
    //     this.$router.push({
    //       name: 'manage-intro-video',
    //       query: { success: 1 },
    //     });
    //   }
    // }
  },
};
</script>

<style></style>
